import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificaciones } from "../../acciones";
import "./noti.css";
import { NavBar } from "../../componentes/navbar";
import { ImgNotifi } from "../../componentes/imgNotifi/imgNoti";

export const Notificaciones = () => {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const notificaciones = useSelector((state) => state.notificaciones);

    useEffect(() => {
        const fetchData = async () => {
            await dispatch(getNotificaciones());
            setLoading(false);
        };
        fetchData();
    }, [dispatch]);

    // Efecto para hacer scroll hacia abajo al cargar las notificaciones
    useEffect(() => {
        if (!loading) {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [loading]);

    if (loading) {
        return <div>Cargando...</div>;
    }

    return (
        <div className="App">
            <NavBar />
            <div className="contnoti">
                {notificaciones.map((noti) => (
                    <ImgNotifi
                        key={noti.notifi_id}
                        img={noti.imgNotifi}
                        titulo={noti.titulo}
                        descripcion={noti.descripcion}
                        notifi_id={noti.notifi_id}
                    />
                ))}
            </div>
        </div>
    );
};
